/**
 * Ecom Text Image GSAP Animations
 * Animates heading word-by-word and text content line-by-line on scroll
 */

(function() {
  const loader = window.DreaverAnimationLoader;
  if (!loader) return;

  loader.register({
    key: 'ecom-text-image',
    sectionSelector: '.ecom-text-image__wrapper',
    targetSelector: '.ecom-text-image__title, .ecom-text-image__subtitle, .ecom-text-image__text',
    animate: setupAnimations
  });

  function setupAnimations(section, { gsap }) {
    const title = section.querySelector('.ecom-text-image__title');
    const subtitle = section.querySelector('.ecom-text-image__subtitle');
    const textElements = section.querySelectorAll('.ecom-text-image__text');

    // Animate Subtitle
    if (subtitle) {
      animateTitle(subtitle, section, gsap);
    }

    // Animate Title - Word by Word
    if (title) {
      animateTitle(title, section, gsap);
    }

    // Animate Text Content - Line by Line
    textElements.forEach((textElement) => {
      animateBodyText(textElement, section, gsap);
    });
  }

  function animateTitle(titleElement, container, gsap) {
    // Store the original HTML
    const originalHTML = titleElement.innerHTML;
    
    // Split text into words while preserving HTML tags
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = originalHTML;
    
    // Function to recursively extract text and wrap words
    function processNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent.trim();
        if (text.length > 0) {
          const textWords = text.split(/\s+/);
          return textWords.map(word => {
            const span = document.createElement('span');
            span.className = 'word-wrapper';
            span.style.display = 'inline-block';
            span.style.overflow = 'hidden';
            span.style.verticalAlign = 'top';
            
            const inner = document.createElement('span');
            inner.className = 'word';
            inner.textContent = word;
            inner.style.display = 'inline-block';
            
            span.appendChild(inner);
            return span.outerHTML;
          }).join(' ');
        }
        return '';
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const tagName = node.tagName.toLowerCase();
        const attributes = Array.from(node.attributes)
          .map(attr => `${attr.name}="${attr.value}"`)
          .join(' ');
        
        let content = '';
        node.childNodes.forEach(child => {
          content += processNode(child);
        });
        
        return attributes 
          ? `<${tagName} ${attributes}>${content}</${tagName}>`
          : `<${tagName}>${content}</${tagName}>`;
      }
      return '';
    }
    
    let processedHTML = '';
    tempDiv.childNodes.forEach(child => {
      processedHTML += processNode(child);
    });
    
    titleElement.innerHTML = processedHTML;

    // Get all word elements
    const wordElements = titleElement.querySelectorAll('.word');

    // Set initial state
    gsap.set(wordElements, {
      y: '100%',
      opacity: 0
    });

    // Create animation
    gsap.to(wordElements, {
      y: '0%',
      opacity: 1,
      duration: 0.8,
      ease: 'power3.out',
      stagger: 0.08,
      delay: 0.2,
      scrollTrigger: {
        trigger: container,
        start: 'top 80%',
        end: 'top 50%',
        toggleActions: 'play none none none'
      }
    });
  }

  function animateBodyText(contentElement, container, gsap) {
    // Simple fade animation for body text
    
    // Set initial state
    gsap.set(contentElement, {
      opacity: 0,
      y: 20
    });

    // Create animation
    gsap.to(contentElement, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power2.out',
      delay: 0.2,
      scrollTrigger: {
        trigger: container,
        start: 'top 75%',
        end: 'top 45%',
        toggleActions: 'play none none none'
      }
    });
  }
})();

